import React from "react";
import "./Services.css";
// import service1 from '../../assets/Images/service1.png';

const Services = () => {
  const servicesData = [
    {
      id: 1,
      title: "Jewellery Manufacturing",
      description:
        "Custom-crafted jewellery designed to meet your unique preferences with precision and quality.",
      // image: service1, // Replace with actual image paths
    },
    {
      id: 2,
      title: "Jewellery Wholesale",
      description:
        "Wholesale jewellery services offering elegant designs and superior quality for businesses.",
      // image: service1, // Replace with actual image paths
    },
    {
      id: 3,
      title: "Diamond Wholesale",
      description:
        "Wholesale supply of high-quality diamonds, including white and fancy color options, for businesses.",
      // image: service1, 
    },
    {
      id: 4,
      title: "Gem Stone Wholesale",
      description:
        "Comprehensive gemstone wholesale services offering both precious and semi-precious stones in diverse cuts and colors.",
      // image: service1, // Replace with actual image paths
    },
  ];

  return (
    <div className="services-container" id="services">
      <h2 className="services-title">Our Services</h2>
      <div className="services-grid">
        {servicesData.map((service) => (
          <div className="service-card" key={service.id}>
            {/* <div className="service-image-container">
              <img src={service.image} alt={service.title} className="service-image" />
            </div> */}
            <h3 className="service-title">{service.title}</h3>
            <p className="service-description">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
